import { render, staticRenderFns } from "./specialGoods.vue?vue&type=template&id=82a5d39c&scoped=true"
import script from "./specialGoods.vue?vue&type=script&lang=js"
export * from "./specialGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a5d39c",
  null
  
)

export default component.exports